// extracted by mini-css-extract-plugin
export default {"bg":"Home_bg__sjuDO","p":"Home_p__HUhaU"};